export const environment = {
  production: true,
  apiUrl: '/api/',
  tiktokRedirectUri: 'https://verticaltalentgroup.com/api/tiktokRedirect',
  tiktokCallbackUri: 'https://verticaltalentgroup.com/tiktokcallback',
  instagramRedirectUri: 'https://verticaltalentgroup.com/api/oauth/instagram/callback',
  youtubeRedirectUri: 'https://verticaltalentgroup.com/api/oauth/youtube/callback'
};
